import * as Styled from '../../policy.styled';

export default function UseRestrictionPolicyJa() {
  return (
    <Styled.MainWrapper style={{ marginTop: 40 }}>
      <h3 style={{ marginBottom: '40px' }}>サービス運営ポリシー</h3>
      本運営ポリシーは、株式会社BubbleTap（以下「当社」といいます）が提供する『Tingle』、『Reward』など（以下「サービス」といいます）の運営において、サービス内で発生する可能性のある問題状況およびサービスに関連するコンテンツ（利用規約第2条第2項参照）の管理について、一貫した対応を行うため、サービス運営の基準と利用者皆様が遵守すべき詳細な事項が定められています。運営ポリシーに違反した場合、違反回数または違反の程度に応じて、当社が提供するサービス全体で不利益を被る可能性がありますので、ご注意ください。また、本運営ポリシーで使用される用語の意義は、利用規約におけるものと同一です。
      <br />
      <br />
      当社は、サービスに関するポリシーを改善するため、会員との継続的な意見交換を通じて合理的な運営ポリシーを策定するよう努めており、その場合、最低7日前までにサービスのお知らせを通じてお知らせいたします.
      <p>第1条 会員の権利と義務</p>
      <ol>
        ① 会員の権利
        <br />
        会員は、オンラインカスタマーセンターなどを通じて、サービスに関する各種お問い合わせをすることができます。
        <br />
        <br />② 会員の義務
        <ol>
          <li>
            会員は、サービス内において法令、利用規約、運営ポリシーなどに違反する行為や、他の会員のサービス利用を妨げる活動をしないものとします。これらの義務に違反した場合、当社内部規定に基づき、別途の通知なしにサービス利用制限措置が講じられる場合があります。
          </li>
          <li>
            会員は、利用規約、運営ポリシーなどの規定および当社ホームページの告知事項などを随時確認する必要があります。これらを確認しないことにより生じる事項については、当社の支援を受けることが困難な場合があります。
          </li>
          <li>
            利用者は、当社およびその他の第三者の著作権などの知的財産権の侵害、名誉毀損、業務妨害行為、その他の関連法令違反事項が発見された場合、サービス利用に制限を受ける可能性があり、関係法令に基づき民事・刑事上の責任が生じる可能性があります。
          </li>
        </ol>
      </ol>
      <p>第2条 サービス利用制限措置</p>
      当社のサービス利用者が、第3条に定める運営方針またはTingle制作規定に違反する行為を行った場合、違反回数または当社が判断する違反行為の重大性に応じて、次の措置を講じます。措置は必ずしも順次適用するものではなく、違反行為の重大性に応じて、段階を飛ばして上位段階の措置を適用することがあります。
      <br />
      <br />
      <ol>
        ① サービス利用に関する段階別措置
        <li>第1段階：ポリシーの案内及び該当内容の非公開または削除。</li>
        <li>
          第2段階：該当内容を非公開または削除した上で、当社が運営する各コミュニティ／SNS機能の利用を最大7日間制限。
        </li>
        <li>第3段階：該当内容を非公開または削除した上で、アカウントの利用を3日間制限。</li>
        <li>第4段階：該当内容を非公開または削除した上で、アカウントの利用を7日間制限。</li>
        <li>第5段階：該当内容を非公開または削除した上で、アカウントの利用を30日間制限。</li>
        <li>第6段階：該当内容を非公開または削除した上で、アカウントの利用を永久に制限。</li>
      </ol>
      <ol>
        ② 創作物、AIキャラクター、AI叙事、AIテーマ等（以下「AIアセット」といいます）の投稿に関する段階別措置
        <li>第1段階：ポリシーの案内及び該当する創作物またはAIアセットの非公開または削除。</li>
        <li>
          第2段階：該当する創作物またはAIアセットを非公開または削除した上で、コンテンツの生成及び利用ツール機能の利用を最大7日間制限。
        </li>
        <li>第3段階：該当する創作物またはAIアセットを非公開または削除した上で、アカウントの利用を3日間制限。</li>
        <li>第4段階：該当する創作物またはAIアセットを非公開または削除した上で、アカウントの利用を7日間制限。</li>
        <li>第5段階：該当する創作物またはAIアセットを非公開または削除した上で、アカウントの利用を30日間制限。</li>
        <li>第6段階：該当する創作物またはAIアセットを非公開または削除した上で、アカウントの利用を永久に制限。</li>
      </ol>
      <ol>
        ③ 制作規定違反時の累積回数別適用基準
        <br />
        制作規定違反に対する措置は、制作規定第4章に定める基準に従い、具体的な適用は次のとおりとします。
      </ol>
      {/* 表は号ではなく ③ の本文だ — ol 内に li で入れると表の左に号番号が付き、後続の文の番号がずれる。 */}
      <div className="table-wrapper">
        <table>
          <colgroup>
            <col style={{ width: '40%' }}></col>
            <col style={{ width: '20%' }}></col>
            <col style={{ width: '40%' }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>違反条項</th>
              <th>違反回数</th>
              <th>適用段階</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan={3}>制作規定第2章第1条</td>
              <td>3回</td>
              <td>②第3段階（アカウント3日間制限）</td>
            </tr>
            <tr>
              <td>5回</td>
              <td>②第4段階（アカウント7日間制限）</td>
            </tr>
            <tr>
              <td>7回</td>
              <td>②第6段階（アカウント永久制限）</td>
            </tr>
            <tr>
              <td rowSpan={2}>制作規定第2章第2条または第3章</td>
              <td>3回</td>
              <td>②第4段階（アカウント7日間制限）</td>
            </tr>
            <tr>
              <td>5回</td>
              <td>②第6段階（アカウント永久制限）</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ol>
        <li>上記の累積回数に達していない違反については、②第1段階または第2段階の措置を適用します。</li>
        <li>
          上記基準とは別に、違反行為が重大であると判断される場合、累積回数にかかわらず、上位段階の措置を適用することがあります。
        </li>
        <li>
          制作規定において別途定められていない違反行為については、違反行為の重大性に応じて、①または②の段階別措置を適用します。
        </li>
      </ol>
      <ol>
        ④ 措置の通知
        <br />
        当社は、利用制限措置を適用する場合、措置の理由、該当する規定の条項、措置の内容及び期間を利用者に通知します。
        {/* li がないため `ol > li:last-child` の margin-bottom が効かない — ⑤ との間隔を br で補正する。 */}
        <br />
        <br />
      </ol>
      <ol>
        ⑤ 異議申請
        <li>利用者は、措置の通知を受けた日から14日以内に、お客様センターを通じて異議申請をすることができます。</li>
        <li>
          異議申請は、次の各号のいずれかに該当する場合に受け付けます。
          {/* 号ラベル（ア・イ・ウ・エ）が文面にあるため、入れ子 ol の disc を切る — 切らないと「• ア．」と二重になる。 */}
          <ol style={{ listStyleType: 'none' }}>
            <li>
              ア．アカウントの盗用等により、利用者本人が作成または投稿していないコンテンツに対して措置が行われた場合。
            </li>
            <li>イ．違反回数の算定に誤りがある場合（同一コンテンツの重複算定等）。</li>
            <li>ウ．措置対象となったコンテンツが当該規定に該当しないと判断できる具体的な理由がある場合。</li>
            <li>
              エ．第三者の権利侵害を理由として措置された案件について、利用者が正当な権利を有していることを確認できる場合。
            </li>
          </ol>
        </li>
        <li>
          当社は、異議申請の受付日から営業日基準で3～5日以内に検討結果を通知し、措置が適切でなかったことが確認された場合には、直ちにサービスの利用を再開します。検討により長い期間を要する場合には、その理由及び予定日程を併せて通知します。
        </li>
        <li>異議申請は、同一の措置について1回に限り受け付けます。</li>
        <li>
          ①及び②の第1段階の措置については、別途の異議申請手続きによらず、お客様センターへの問い合わせを通じて再検討を求めることができます。
        </li>
        <li>
          異議申請の受付の有無にかかわらず、措置は予定どおり適用され、検討結果に応じてサービスの利用を再開します。
        </li>
        <li>
          異議申請の過程において、当社に対して継続的に暴言、脅迫等を行い、正常な業務の遂行を困難にする行為がある場合、当社は当該異議申請に関する後続手続きを行わないことがあります。
        </li>
      </ol>
      <p>第3条 利用制限対象行為 </p>
      利用者が以下の行為を行う場合、第2条の利用制限措置事由に該当します。
      <br />
      <br />
      <ol>
        ① サービス利用に関する制限活動
        <li>
          個人情報の侵害
          <ol>
            <li>他者の情報を暴露する行為</li>
            <li>他の会員のアカウントを不正に使用する行為</li>
            <li>アカウントを他者に譲渡したり共有したりするなど、アカウントを不正に使用したと合理的に疑われる行為</li>
            <li>他の会員の個人情報をその同意なしに収集、保存、公開する行為</li>
          </ol>
        </li>
        <li>
          ハッキング
          <ol>
            <li>携帯電話のハッキングなどを通じてUUIDを改変してサービスを利用する行為</li>
            <li>
              当社から特別な権限を付与されずに、当社のクライアントプログラムを変更したり、サーバーをハッキングする行為
            </li>
            <li>
              当社が未然に把握または修正していないサービスの脆弱性を悪用してサービスを利用したり、非公開資料を閲覧して情報を偽造・改ざんする行為
            </li>
            <li>
              自動接続プログラムなどを使用するなど、通常の利用方法と異なる方法でサービスを利用し、当社のサーバーに負荷をかけて当社の通常のサービスを妨害する行為
            </li>
          </ol>
        </li>
        <li>
          違法な営利活動
          <ol>
            <li>違法なギャンブルサイトのプロモーション</li>
            <li>違法な製品の販売またはプロモーション</li>
            <li>当社から同意を得ていない、または当社の利用規約などで禁止されている営利活動を行う行為</li>
            <li>
              サービスの安定した運営を妨げる可能性のある情報、または受信者の明示的な受信拒否の意思に反して広告情報またはスパムメール（Spam
              Mail）を送信する行為
            </li>
            <li>犯罪と関連していると客観的に判断される行為</li>
            <li>その他の関係法令に違反するまたは違法または不当な行為</li>
          </ol>
        </li>
        <li>
          著作権侵害
          <ol>
            <li>
              当社および他の会員またはその他の第三者の特許、商標、営業秘密、著作権、その他の知的財産権を侵害する内容を掲載または使用したり、その他の方法で第三者に拡散する行為
            </li>
            <li>
              当社サービスを利用して取得した情報を、適法な権限または当社の承諾なしに複製または流通させたり、営利的に使用する行為
            </li>
            <li>他人の著作物を違法な手段で取得できる情報または方法を提供する行為</li>
            <li>放送、音楽、映画、漫画など他人の著作物を当事者の同意なしに共有する行為</li>
            <li>他人の権利に属する商標権、意匠権などを無断で侵害する行為</li>
            <li>著作権者から権利侵害の申告が提出された著作物に対する侵害行為</li>
            <li>上記行為以外の著作権侵害行為に該当する場合</li>
          </ol>
        </li>
        <li>
          サービス利用の妨害
          <ol>
            <li>
              羞恥心や嫌悪感、恐怖心を煽る卑猥な言葉や罵倒、スパム投稿、ストーキングなど、他の会員のサービス利用を妨げる行為
            </li>
            <li>
              検索流入を目的として、人間の力では困難だと見られる過剰な投稿をアップロードし、悪意ある目的と判断される行為
            </li>
            <li>出典が不明な投稿を掲載したり、デマを流布する場合</li>
          </ol>
        </li>
        <li>
          わいせつ物の拡散
          <ol>
            <li>わいせつサイトへのリンクを張る行為</li>
            <li>性売買に関する情報を共有する行為</li>
          </ol>
        </li>
        <li>
          差別および対立の助長
          <ol>
            <li>性別、宗教、障害、年齢、社会的地位、人種、地域、職業などに基づく差別や偏見を助長する活動を行う場合</li>
            <li>政治的扇動や誘導を行う行為を行う場合</li>
            <li>上記以外の差別や対立を助長する行為を行う場合</li>
          </ol>
        </li>
        <li>
          投稿物の投稿
          <ol>
            <li>投稿の作成または変更時に虚偽の内容を登録する行為</li>
            <li>不正または違法なプログラムの配布や利用方法を含む内容を投稿した場合</li>
            <li>事前に承認されていない他者の著作物を使用して投稿を作成した場合</li>
            <li>他者の著作物を違法な手段で入手できる情報や方法に関する内容を投稿した場合</li>
            <li>同じ内容の投稿を繰り返し登録し、他者のサービス利用を妨げる場合</li>
            <li>わいせつ物を掲載したり、性売買に関する情報を投稿した場合</li>
            <li>他者に対して蔑視や非難、暴言などの行為を行う場合</li>
            <li>
              性別、宗教、障害、年齢、社会的地位、人種、地域、職業などに基づく差別や偏見を助長する内容を投稿する場合
            </li>
            <li>政治的扇動や誘導する内容を投稿した場合</li>
            <li>上記項目以外で、他者のサービス利用を妨害したり、違法な内容を含む記事を投稿する場合</li>
          </ol>
        </li>
        <li>
          その他
          <ol>
            <li>当社または関係者を装う行為</li>
            <li>当社およびその他の第三者の名誉を損なうまたは不利益を与える行為</li>
            <li>当社が投稿した情報を変更する行為</li>
            <li>
              ニックネーム、投稿、コメントにおいて、当社、他の企業または著作権者と関連する事項を偽装するなど、サービスの適切な利用以外の目的でサービスを悪用する意図があると判断される行為を行う場合
            </li>
            <li>サービスを利用しない意思を表明し、再加入制限に同意した後にサービスを退会した場合</li>
            <li>上記項目以外で、サービスで禁止されている活動を行った場合</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② 創作物およびAIアセットの投稿に関する制限
        <li>
          活動
          <ol>
            <li>成人向けコンテンツ</li>
            <li>成人向けコンテンツの表示なしに成人向けコンテンツを投稿する場合</li>
            <li>成人向けコンテンツに該当するコンテンツの年齢制限を任意に変更する場合</li>
            <li>
              情報通信に関する審査規定で定義された流通禁止の描写や、社会通念上容認されにくい行為を集中的に描写した場合
            </li>
            <li>性器など性的部位や行為を、別途のモザイク（輪郭が識別できないレベル以上）なしに露骨に描写した場合</li>
            <li>その他の関係法令違反により緊急の措置が必要と判断される場合</li>
          </ol>
        </li>
        <li>
          児童虐待
          <ol>
            <li>
              児童・青少年の性保護に関する法律に基づき、社会通念に照らして児童・青少年（18歳未満）が登場し性的行為を行う内容を表現した場合
            </li>
            <li>児童・青少年として明確に認識できる人物や表現物が登場し、性的行為を行う内容を表現した場合</li>
          </ol>
        </li>
        <li>
          暴力
          <ol>
            <li>
              自傷、自殺など、深刻な怪我や死に至る可能性のある行為、その他精神的・身体的虐待を美化または助長するもの
            </li>
            <li>
              薬物や武器の使用など犯罪を美化したり、爆弾や武器の製造など犯罪方法を現実的に描写して犯罪を助長するもの
            </li>
            <li>
              誘拐、人身売買、殺人、傷害、拷問、身体損傷、臓器売買など、残虐で暴力的な場面を具体的に描写したり助長するもの
            </li>
            <li>
              親族、高齢者、妊婦、障害者、児童、社会的弱者に対する脅迫・傷害・暴行・殺人などを具体的に描写したり美化して、伝統的な倫理を損なうおそれがあるもの
            </li>
            <li>実際の犯罪や事件の被害者に対する侮辱や憎悪を助長するもの</li>
            <li>動物の殺害、虐待、死体などを具体的に表現し、残虐感または嫌悪感を与える内容</li>
          </ol>
        </li>
        <li>
          差別的表現
          <ol>
            <li>
              人種、民族、宗教、障害、年齢、国籍、性的指向、性別、性的アイデンティティ、規範や社会構造の体系などを理由に、個人や集団に対する暴力や憎悪を助長する場合
            </li>
            <li>他の利用者に嫌悪感や不快感を起こす表現を使用した場合</li>
            <li>社会の平和秩序または美風良俗を害する、または害する目的の描写</li>
          </ol>
        </li>
        <li>
          違法行為の誘導および描写
          <ol>
            <li>性売買・わいせつな情報を提供した場合</li>
            <li>賭博情報を提供した場合</li>
            <li>違法な食品・医薬品情報を提供した場合</li>
            <li>ハッキングソフトウェアまたはソースコード情報を提供した場合</li>
            <li>犯罪を教唆・幇助したり、宣伝・扇動するおそれがあるもの</li>
            <li>サービス関係者またはサービスを装ったり、その誤解を招くおそれがあるもの</li>
            <li>その他、違法行為の計画または実行を具体的に描写したもの</li>
            <li>その他の法令（違法金融、個人情報取引など）違反情報を提供した場合</li>
          </ol>
        </li>
        <li>
          広告
          <ol>
            <li>
              表示・広告の公正化に関する法律上、広告性コンテンツは消費者がその事実を容易に認識できるよう、経済的利益関係を明確に表示する文言を挿入していない場合
            </li>
            <li>違法、賭博性サイトを直接的または間接的に宣伝する場合</li>
            <li>違法製品の販売を直接的または間接的に宣伝する場合</li>
          </ol>
        </li>
        <li>
          著作権
          <ol>
            <li>自身の創作物でない場合</li>
            <li>著作物を原著作者の許可を得ずに使用した場合</li>
            <li>原作と原著作者が明確な著作物の全部または一部を無断で使用した場合</li>
            <li>
              原作および原著作者が広く知られており、適法な流通経路が明確な創作物の全部の無断転載・配布など、著作権侵害が明確に認識される場合
            </li>
          </ol>
        </li>
        <li>
          コンテンツ形式
          <ol>
            <li>コンテンツに関連する定量的な数値（例：チャット数、いいね数など）を人為的に操作する場合</li>
            <li>
              通常のコンテンツではない場合（例：コンテンツの内容がなかったり、サービスの本来の趣旨に合致しないコンテンツ）
            </li>
            <li>その他、コンテンツの内容がサービスの掲載に不適切であると判断される場合</li>
          </ol>
        </li>
        <li>
          その他
          <ol>
            <li>当社、他の会員または第三者を誹謗中傷し、名誉を損なう場合</li>
            <li>公共の秩序および善良の風俗に違反する内容の情報、文章、図形等の拡散に該当する場合</li>
            <li>
              出版倫理委員会（現・出版文化産業振興院）および韓国放送通信審議委員会(韓国の公的機関や関連団体)が定める有害出版物の審議基準に違反する場合
            </li>
            <li>犯罪行為と関連していると認められる内容の場合</li>
            <li>当社または第三者の著作権その他の権利を侵害する内容の場合</li>
            <li>承認されていない広告や販促物を掲載する場合</li>
            <li>出所が不明な投稿を掲載したり、虚偽の情報を拡散する場合</li>
          </ol>
        </li>
      </ol>
      <p>第4条 サービス利用における通報制度の運営</p>
      ①
      会員は、関連法令、サービス利用規約、本運営ポリシーなどに違反する投稿物を確認した場合、いつでも当社に通報するなどの措置を講じることができます。
      <br />
      <br />
      ②
      通報する際は、通報対象の出典（URLなど）と理由を併せて提出する必要があります。これらの出典と理由は当社担当者に伝達され、担当者はこれを基に制限の可否を慎重に検討します。
      <br />
      <br />
      ③
      報告者の考えとは異なり、当該報告対象が明確に関連法令、サービス利用規約、本運営ポリシーなどに違反していると判断されない場合、措置が講じられない場合があります。
      <br />
      <br />
      ④
      既に報告事項に関する判断が下された事案であっても、後日、裁判所の判決や権限を有する行政機関の処分などにより、以前の判断に問題があったことが判明した場合、当社の既存の判断が変更される可能性があります。
      <br />
      <br />⑤
      報告内容の審査过程中、対象に対する措置の有無だけでなく、追加で当該会員アカウントの利用制限が行われる場合があります。この場合、当該会員のサービス利用履歴、運営ポリシー等違反履歴とその軽重、関連法令、サービス利用規約、本運営ポリシーなどを総合的に考慮して決定します。
      <p>第5条 サービス休眠ポリシー（長期未ログイン会員に対する措置） </p>
      ① 1年間ログインしない場合、個人情報を分離保管
      <br />
      <br />
      ② 個人情報分離保管後、4年間ログインしない場合、個人情報を破棄し、利用契約を解除
      <br />
      <p>第6条 返金濫用禁止</p>
      ①
      返金濫用：利用者が当社のデジタル商品またはサービスを当社のアプリ内通貨（利用規約第2条第1項参照）で購入し、これを消費した後、Google
      Play Console、Apple App
      Store、またはその他の機関を通じて消費したポイント資産に対する返金を請求する返金濫用およびデジタル窃盗は、詐欺的な不正行為および窃盗とみなされます。当社は、これらの行為を利用規約および運営ポリシー違反とみなします。
      <br />
      <br />
      ②
      返金濫用事例に関する当社の決定は最終的です。利用者は、これに対して異議を申し立てる権利を放棄し、当社の決定に従うことに同意します。
      <br />
      <br />③ 返金濫用に巻き込まれた利用者は、以下の通り処理されます。
      <ol>
        <li>
          法적措置：当社は、返金濫用に巻き込まれたと確認されたすべての利用者に対し、法的措置を講じる権利を有します。当社は関連法令に従い、返金濫用により当社が被った損害を回復するための民事訴訟を提起します。
        </li>
        <li>
          永久禁止：返金濫用に巻き込まれた利用者は、会社プラットフォームから永久に禁止されます。この禁止措置は、関連する利用者のすべてのアカウントとデバイスに適用され、当該利用者は無期限に当社サービスの利用が禁止されます。
        </li>
      </ol>
      ④ 無寛容（zero-tolerance
      policy）ポリシー：当社は、返金不正利用に対して無寛容ポリシーを維持しています。当社は、プラットフォームの健全性保護、利用者への効果的なサービス提供、およびコンテンツクリエイターの権利保護を目的とし、すべての利用者に公平で透明な体験を保証するために最善を尽くしています。
      <br />
      <br />⑤
      利用者の義務：当社プラットフォームのサービスを利用することにより、利用者は以下の事項に同意するものとします。
      <ol>
        <li>あらゆる形態の返金濫用行為を行いません。</li>
        <li>利用規約および運営ポリシーを常に遵守します。</li>
        <li>返金濫用の疑いがある事例を発見した場合、直ちに当社に報告します。</li>
      </ol>
    </Styled.MainWrapper>
  );
}
